import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";

/*
gt: verificare se un campo è maggiore di un valore costante
lt: verificare se un campo è minore di un valore costante
ge: verificare se un campo è maggiore o uguale a un valore costante
le: verificare se un campo è minore o uguale a un valore costante
*/
export const ElaboraStatistica: AnaColumn[] = [

/*
  {
    itemType: "group", caption: "", colCount: "2", colSpan: '2', data: [

      {
        type: 'campoSpecial', colVisible: true, dataField: "idCausale",
        dataType: "",
        width: 40 + 'vw',
        colWidth: '100',
        caption: "Causale",
        orderGriglia: 1,
        editorType: 'dxTagBox',
        tagBoxList: {
          dataSource: 'CausaleRifiuti',
          displayExpr: 'descrizione',
          valueExpr: 'id',
          maxDisplayedTags: 4,
          multiline: false,
          showSelectionControls: true,
        }

      },

      {
        type: 'campoSpecial', dataField: "idPosizione", dataType: "",
        editorType: 'dxTagBox',
        width: 40 + 'vw',
        colVisible: false,
        caption: "Posizione",
        labelVisible: true,
        tagBoxList: {
          dataSource: 'PosizioneRifiuti',
          displayExpr: 'descrizione',
          valueExpr: 'id',
          maxDisplayedTags: 4,
          multiline: false,
          showSelectionControls: true,

        }
      },
      
    ]
  },
  */
  {
    itemType: "group", class:'group-width50N formTab', caption: "Dati generali documento e rifiuto", colCount: "6", colSpan: "2", data: [
      {
        odataType:'date', odataFilter:'ge',      
        type: 'campoData', dataType: 'date', dataField: 'daDataRegistrazione', caption: 'Da Data Registr.',
        colVisible: true, format: "dd/MM/yyyy", editorType: "dxDateBox", colWidth: '105', width: 9 + 'vw', orderGriglia: 2,
      },
      {
        odataType:'date', odataFilter:'le',
        type: 'campoData', dataType: 'date', dataField: 'aDataRegistrazione', caption: 'A Data Registr.',
        colVisible: true, format: "dd/MM/yyyy", editorType: "dxDateBox", colWidth: '105', width: 9 + 'vw', orderGriglia: 2,
      },
      {
        odataType:'string', odataFilter:'contains',
        type: 'campo', dataType: '', dataField: 'numDocumentoInterno', caption: 'N.docum.',
        width: 9 + 'vw', colVisible: true, maxLength: '15', colWidth: '105', orderGriglia: 5,
      },
      {
        odataType:'string', odataFilter:'contains',
        type: 'campo', dataType: '', dataField: 'riferimentoDocumento', caption: 'Rif.docum.',
        width: 9 + 'vw', colVisible: true, maxLength: '15', colWidth: '105', orderGriglia: 5,
      },
      {
        type: 'campo', dataType: '', dataField: 'scontrino', caption: 'Scontrino',
        width: 9 + 'vw', colVisible: true, maxLength: '10', orderGriglia: 6,
      },

      /*
      {
        type: 'campo', dataType: '', dataField: 'protocollo', caption: 'Protocollo',
        width: 9 + 'vw',
        colVisible: false,
        maxLength:'6'
      },
      */
      {
        type: 'campo', dataType: '', dataField: 'numeroFormulario', caption: 'N.Formulario',
        maxLength: '20', maxSize: 20, width: 9 + 'vw', colWidth: '105', orderGriglia: 3,
        colVisible: true
      },
      
      /*
      {
        type: 'campo', dataType: '', dataField: 'peso', caption: 'Peso Netto',
        maxLength: '6', width: 9 + 'vw',
        editorType:'dxNumberBox',hideOnEdit:false,
        //defaultValue:0,
        colVisible: true
      },
      */

      {
        type: 'campo', dataType: 'number', dataField: 'minPeso', caption: 'Peso Minimo',
        maxLength: '6', width: 9 + 'vw',
        editorType:'dxNumberBox',hideOnEdit:false,
        colVisible: true,min:1

      },
      {
        type: 'campo', dataType: 'number', dataField: 'maxPeso', caption: 'Peso Massimo',
        maxLength: '6', width: 9 + 'vw',
        editorType:'dxNumberBox',hideOnEdit:false,
        colVisible: true,min:1,
      },

      /***CER***/

      {
        type: 'campoSpecial', colVisible: true, dataField: "cer",
        width: 9 + 'vw',
        maxLength: '6',
        caption: "EER.",
        
        editorType:'dxAutocomplete',
        lista: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'cer',
          static:false,
        },
        
      },


      {
        type: 'campoSpecial', dataField: "idStatoFisico", dataType: "", caption: "Stato fisico.",width: 9 + 'vw',
        colVisible: false,
        labelVisible: true,
        editorType: 'dxSelectBox',
        lista: {
          dataSource: 'StatoFisico',
          displayExpr: 'descrizione',
          valueExpr: 'id',
          static: false
        },
        /*
        validation: [
          { type: 'required', message: 'Campo obbligatorio' }
        ]
        */

      },
      //{ type: 'empty', dataField: '', dataType: '' },



      /*****Tipo Docu*****/

      {
        type: 'campoSpecial', colVisible: false, dataField: "idTipodocumento",

        width: 9 + 'vw',
        maxLength: '10',
        caption: "Tipo doc.",
        editorType:'dxSelectBox',
        lista: {
          
          queryString: '?nomeTabella=soggetti',
          dataSource: 'Tipo',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static:false
          
        }

      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idCategoriaDocumento",
        
        width: 9 + 'vw',
        maxLength: '10',
        caption: "Categ. doc.",
        editorType:'dxSelectBox',
        lista: {
          
          queryString: '?nomeTabella=soggetti',
          dataSource: 'Categoria',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static:false
        }
        
      },
      {
        type: 'campo', dataField: "riferimentoCer", dataType: "", caption: "Rif.EER",width: 9 + 'vw',
        colVisible: false,
        labelVisible: true,
        maxLength: '10',


      },

      {
        type: 'campoData',
        dataField: "daDataIniziotrasporto",
        caption: "Da Data Inizio Trasp.",
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        dataType: "date", //datetime
        maxLength: '15',
        width: 9 + 'vw',
        colVisible: false,

      },      
      {
        type: 'campoData',
        dataField: "aDataFinetrasporto",
        caption: "A Data Fine Trasp.",
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        dataType: "date", //datetime
        maxLength: '15',
        width: 9 + 'vw',
        colVisible: false,

      },      
      {
        type: 'campoSpecial', colVisible: false, dataField: "idZonaDocumento",

        width: 9 + 'vw',
        maxLength: '10',
        caption: "Zona racc.",
        editorType:'dxSelectBox',
        lista: {
          
          queryString: '?nomeTabella=soggetti',
          dataSource: 'Zona',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static:false
          
        }

      },
      { type: 'empty', dataField: '', dataType: '' },
    
      { type: 'empty', dataField: '', dataType: '' },
    


    ]
  },
  {
    itemType: "group", caption: "Produttore", colSpan:"2", colCount: "2", class: 'group-width25 formTab',groupDataField:'produttore', data: [
      {
        type: 'campoSpecial',
        colVisible: false,
        dataField: "idProduttore",
        editorType: 'dxLookup',
        width: 24.2 +'vw',
        caption: "Produttore",
          
        lista: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: 'descrizione',
          dataSource: "Sede/GetAllSoggettiSedi?$filter=( isproduttore eq true )",
          static: false,
          cascading: ['id|idMagazzinoProduttore','id|idAutorizzazioneProduttore'],
          colonne: [
            {
              dataField: 'id',
              caption: 'Codice',
              width:80,
              alignment:'left'
            },
            {
              dataField: 'descrizione',
              caption: 'Descrizione'
            },
            {
              dataField: 'descrizioneSoggetto',
              caption: 'Azienda',
              groupIndex:1
            }
          ]

        },
        /*
        validation: [
          { type: 'required', message: 'Campo obbligatorio' }
        ]
        */
      },

      { type: 'empty', dataField: '', dataType: '' },

      /* {
        type: 'campoSpecial', dataField: "descProduttore", dataType: "", caption: "Produttore",
        width: 24.2 +'vw',
        colVisible: false,
        labelVisible: true,
        disableOnUpdate: true,

        dynamic: {

          dataSource: "Sede/GetAllSoggettiSedi?$filter=( isproduttore eq true )",
          service: 'sede',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Lista Produttori",
          queryString: '',
          componentType: 'grid',
          related: ['id|idProduttore'],
          enableEditor: false,
          buttonOption: {
            text: 'Zone',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Produttore',
            name: 'produttore',
            location: 'after',
          },


        }
      }, */

      /***Autorizzazione Produttore ***/
      {
        type: 'campoSpecial', colVisible: false, dataField: "idAutorizzazioneProduttore",
        editorType: "dxSelectBox",
        disableOnUpdate:true,
        width: 9.2 +'vw',
        caption: "Autorizz.",
        
        lista: {
          valueExpr: 'id',
          queryString: '/$idProduttore',
          displayExpr: 'numero',
          dataSource: 'Autorizzazione',
          static:false,
        }

      },
      
     
      /*
      {
        type: 'campoSpecial', colVisible: false, dataField: "idMagazzinoProduttore",
        editorType: "dxSelectBox",
        dataType: "number",
        class: 'd-none',
        hideOnEdit: true,
        width: 8 * aspect,
        caption: "Magazzino.",
        disableOnUpdate: true,
        lista: {
          valueExpr: 'id',
          queryString: '?idSede=$idProduttore',
          displayExpr: '',
          dataSource: 'magazzinoRifiuti',

          caption: "Lista magazzino rifiuti",
   
          related: ['descrizione|descMagazzino'],
  

        }
        
      },
      */
      {
        type: 'campoSpecial', dataField: "idMagazzinoProduttore", dataType: "", caption: "Magazzino",
        width: 8.8 +'vw',
        colVisible: true,
        editorType:'dxSelectBox',
        labelVisible: true,
        disableOnUpdate:true,
        lista: {
          valueExpr: 'id',
          queryString: '?idSede=$idProduttore', //?idSede=$idProduttore
          displayExpr: 'descrizione',
          dataSource: 'magazzinoRifiuti',
          static:false,
          //related: ['descrizione|descMagazzino'],
  

        }

      },
      


    ]
  },
  {
    itemType: "group", caption: 'Trasportatore ', groupDataField: 'Trasportatore', class: 'group-width50 formTab', colCount: '2', data: [

      {
        type: 'campoSpecial',
        colVisible: false,
        dataField: "idTrasportatore",
        editorType: 'dxLookup',
        width: 24.2 +'vw',
        caption: "Trasportatore",
          
        lista: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: 'descrizione',
          dataSource: "Sede/GetAllSoggettiSedi?$filter=( istrasportatore eq true )",
          static: false,
          cascading: ['id|idAutomezzo','idSoggetto|idAlbo','idSoggetto|idAutista'], 
          colonne: [
            
            {
              dataField: 'id',
              caption: 'Codice',
              width:80,
              alignment:'left'
            },
            
            {
              dataField: 'descrizione',
              caption: 'Descrizione'

            },
            {
              dataField: 'descrizioneSoggetto',
              caption: 'Azienda',
              groupIndex:1
            }
          ]

        },
        /*
        validation: [
          { type: 'required', message: 'Campo obbligatorio' }
        ]
        */

      },
     
      { type: 'empty', dataField: '', dataType: '', caption: '' },      

      /**Albo e Categoria Albo**/
      {
        type: 'campoSpecial', dataField: "idAlbo", dataType: "", caption: "Iscriz.Albo ",
        width: 9.2 +'vw',
        editorType:'dxSelectBox',
        colVisible: false,
        labelVisible: true,
        disableOnUpdate: true,
        lista: {
          dataSource: 'Albo',
          valueExpr: 'id',
          displayExpr: 'numero',
          queryString: '/$idTrasportatore',
          cascading: ['id|idCategoriaAlbo'],
          static:false
        }
      },
       
      {
        type: 'campoSpecial',
        dataField: "idCategoriaAlbo",
        width: 8.8 +'vw',
        editorType:'dxSelectBox',
        caption: "Categ. albo",
        colVisible: false,
        labelVisible: true,
        disableOnUpdate: true,
        lista: {
          valueExpr: 'id',
          queryString: '/$idAlbo',
          displayExpr: 'tipoIscrizione',
          dataSource: 'AlboCategoria',
          static:false
        }
      },
     
       /**Automezzo***/
      {
        type: 'campoSpecial', colVisible: false, dataField: "idAutomezzo",
        editorType:'dxSelectBox',  
        width: 9.2 +'vw',
        caption: "Targa Automezzo",
        disableOnUpdate: true,
        lista: {
          valueExpr: 'id',
          queryString: '/$idTrasportatore',
          displayExpr: 'targa',
          dataSource:'Automezzo',
          static:false
          //related: ['targa|descAutomezzo'],
        }
      },
     
      /**Autista***/
      {
        type: 'campoSpecial', colVisible: false, dataField: "idAutista",labelVisible:true,
        editorType:'dxSelectBox',  
        width: 8.8 +'vw',
        caption: "Matricola Autista",
        disableOnUpdate: true,
        lista: {
          valueExpr: 'id',
          queryString: '/$idTrasportatore',
          displayExpr: 'matricola',
          dataSource: 'Autista',
          static:false

        }

      },

    ]
  },  
  {
    itemType: "group", caption: "Destinatario", colCount: "2", groupDataField: 'Destinatario', class: 'group-width25 formTab', data: [
      {
        type: 'campoSpecial',
        colVisible: false,
        dataField: "idDestinatario",
        editorType: 'dxLookup',
        width: 14.2 +'vw',
        caption: "Destinatario",
          
        lista: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: 'descrizione',
          dataSource: "Sede/GetAllSoggettiSedi?$filter=( issmaltitore eq true )",
          static: false,
          cascading: ['id|idMagazzinoDestinatario','idSoggetto|idAutorizzazioneDestinatario'], 
          colonne: [
            {
              dataField: 'id',
              caption: 'Codice',
              width:80,
              alignment:'left'
            },
            {
              dataField: 'descrizione',
              caption: 'Descrizione'

            },
            {
              dataField: 'descrizioneSoggetto',
              caption: 'Azienda',
              groupIndex:1
            }
          ]

        },
        /*
        validation: [
          { type: 'required', message: 'Campo obbligatorio' }
        ]
        */

      },
      { type: 'empty', dataField: '', dataType: '', caption: '' },      
      {
        type: 'campoSpecial', colVisible: false, dataField: "idAutorizzazioneDestinatario",
        editorType: "dxSelectBox",
        width: 9.2 +'vw',
        caption: "Autorizz.",
        disableOnUpdate: true,
        lista: {
          valueExpr: 'id',
          queryString: '/$idDestinatario',
          displayExpr: 'numero',
          dataSource: 'Autorizzazione',
          static:false

        }

      },


      {
        type: 'campoSpecial', colVisible: false, dataField: "idMagazzinoDestinatario",
        width: 8.8 +'vw',
        caption:'Magazzino',
        editorType:'dxSelectBox',
        labelVisible: true,
        disableOnUpdate: true,
        lista: {
          valueExpr: 'id',
          queryString: '?idSede=$idDestinatario',
          displayExpr:'descrizione',
          dataSource: 'magazzinoRifiuti',
          static:false

        }

      },

/*
      {
        type: 'campoSpecial', dataField: 'idOperazioneRD', dataType: '', caption: 'Mod. smaltimento',
        colVisible: true,
        colWidth: '100',
        width: 3.6 + 'vw',

        editorClass: 'text-uppercase',
        dynamic: {
          displayExpr: 'id',
          dataSource: 'OperazioneSmaltimento',

          autocomplete: false,

          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: 'id',

          caption: "Lista Modalità di smaltimento",

          componentType: 'grid',
          related: ['descrizione|descOperazioneRD'],
          enableEditor: false,


        }

      }*/
    ]
  },
  {
    itemType: "group", caption: "Intermediario", groupDataField: 'Intermediario', colCount: "2", class: 'group-width25 formTab', data: [
      {
        type: 'campoSpecial',
        colVisible: false,
        dataField: "idIntermediario",
        editorType: 'dxLookup',
        width: 14.2 +'vw',
        caption: "Intermediario",
          
        lista: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: 'descrizione',
          dataSource: "Sede/GetAllSoggettiSedi?$filter=( isintermediario eq true )",
          static: false,
          cascading: ['idSoggetto|idAutorizzazioneIntermediario'], 
          colonne: [
            {
              dataField: 'id',
              caption: 'Codice',
              width:80,
              alignment:'left'
            },
            {
              dataField: 'descrizione',
              caption: 'Descrizione'

            },
            {
              dataField: 'descrizioneSoggetto',
              caption: 'Azienda',
              groupIndex:1
            }
          ]

        },
        /*
        validation: [
          { type: 'required', message: 'Campo obbligatorio' }
        ]
        */

      },
      { type: 'empty', dataField: '', dataType: '' },

      {
        type: 'campoSpecial', colVisible: false, dataField: "idAutorizzazioneIntermediario",
        width: 9.2 +'vw',
        editorType:'dxSelectBox',
        labelVisible: true,
        disableOnUpdate: true,
        caption: "Autorizz.",
        lista: {
          valueExpr: 'id',
          queryString: '/$idIntermediario',
          displayExpr: 'numero',
          dataSource: 'Autorizzazione',
          static:false
        }

      },
      { type: 'empty', dataField: '', dataType: '' },

    ]
  },

 

]